// extracted by mini-css-extract-plugin
export default {"plugin-menu-root":"_2PyG1","pluginMenuRoot":"_2PyG1"};